import { Smartphone, Megaphone, Film, Check } from "lucide-react";

/**
 * Category configuration for deliverables
 * Used across custom package builder, package card, and plan deliverables
 */
export const CATEGORY_CONFIG = {
  standard: {
    title: 'Standard Upgrades',
    icon: Check,
    bgColor: 'bg-gray-50',
    borderColor: 'border-gray-300',
    textColor: 'text-gray-700'
  },
  mobile: {
    title: 'Mobile Experience',
    icon: Smartphone,
    bgColor: 'bg-green-50',
    borderColor: 'border-green-400',
    textColor: 'text-green-700'
  },
  venue: {
    title: 'In Show/Venue',
    icon: Megaphone,
    bgColor: 'bg-green-50',
    borderColor: 'border-green-400',
    textColor: 'text-green-700'
  },
  media: {
    title: 'Social/Media',
    icon: Film,
    bgColor: 'bg-green-50',
    borderColor: 'border-green-400',
    textColor: 'text-green-700'
  }
} as const;

export type CategoryType = keyof typeof CATEGORY_CONFIG;
